<script>
    import { push } from "svelte-spa-router";
    import GeneralHeaderBar from "../../../../common/header/GeneralHeaderBar.svelte";
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from "svelte";

    let dispatch = createEventDispatcher();

    export let guide;

    let code = "";

    let box0;
    let box1;
    let box2;

    window.onload = function () {
        box0.focus();
    };

    addEventListener("keydown", (event) => {
        if (event.key === "Backspace") {
            if (code.length === 0) return;

            setTimeout(() => {
                if (code.length == 1) {
                    if (document.activeElement == box0) {
                        //box0.focus();
                        code = "";
                    } else {
                        box0.focus();
                    }
                } else if (code.length == 2) {
                    if (document.activeElement == box1) {
                        //box0.focus();
                        code = code.substring(0, 1);
                    } else {
                        box1.focus();
                    }
                } else if (code.length == 3) {
                    if (document.activeElement == box2) {
                        //box1.focus();
                        code = code.substring(0, 2);
                    } else {
                        box2.focus();
                    }
                }

                console.log(code);
            }, 50);
        } else if (event.key === "Enter") {
            onSubmit();
        }
    });

    addEventListener("keypress", (event) => {
        if (parseInt(event.key) >= 0 && parseInt(event.key) <= 9) {
            if (code.length > 2) return;

            setTimeout(() => {
                code = box0.value + box1.value + box2.value;
                console.log(code);

                if (code.length == 1) {
                    box1.focus();
                } else if (code.length == 2) {
                    box2.focus();
                }
            }, 50);
        } else if (event.key === " ") {
            if (document.activeElement == box0) {
                box1.focus();
            } else if (document.activeElement == box1) {
                box2.focus();
            } else if (document.activeElement == box2) {
                return;
            }
        }
    });

    async function onSubmit() {
        if (code.length !== 3) return;

        push(
            `/audio-guide/${guide.id}/${
                guide.tracks.find((track) => track.trackId === code).id
            }`
        );
    }
</script>

<GeneralHeaderBar backgroundColor="transparent">
    <div slot="post-title" on:click={() => dispatch("close")}>
        <img src="./images/icons/close.svg" alt={$_("close")} />
    </div>
</GeneralHeaderBar>

<div class="input-row">
    <input
        type="number"
        class="headline-l letterbox"
        autocorrect="false"
        maxlength="1"
        bind:this={box0}
    />
    <input
        type="number"
        class="headline-l letterbox"
        autocorrect="false"
        maxlength="1"
        bind:this={box1}
    />
    <input
        type="number"
        class="headline-l letterbox"
        autocorrect="false"
        maxlength="1"
        bind:this={box2}
    />
</div>

<div class="text-m bottom-text">
    <span style="max-width: 196px;">
        {$_("enter_code")}
    </span>
</div>

<style>
    .bottom-text {
        margin: 32px 0px;
        width: 100%;
        height: auto;
        text-align: center;
    }

    .input-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 96px 16px 32px 16px;
        height: 128px;
    }

    .letterbox {
        width: 31.5%;
        max-width: 128px;
        height: 100%;
        border: 1px var(--black-100) solid;
        text-align: center;
        padding: 10px 0 0 0;
    }
</style>
